const isNodeOrChild = (parent, child) => {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};
export {
  isNodeOrChild
};
//# sourceMappingURL=is-node-or-child.js.map
